import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { DiffuseEndOfStayAppreciationsInput, DiffuseEndOfStayAppreciationsResponse } from './types'

/** Shares the centres' end-of-stay ratings (TEFL teachers, host families) with their provider. */
export const diffuseCenterEndOfStayAppreciations = (input: DiffuseEndOfStayAppreciationsInput) => {
  return restApiClient
    .url(constructApiUrl(API.centers.diffuseEndOfStayAppreciations.url, null))
    .post<DiffuseEndOfStayAppreciationsResponse>(input)
}
